<template>
    <div class="form-group">
        <label for="versions">{{$lang('Wersje')}}</label>
        <multiselect
            :searchable=false :close-on-select=false
            id="versions" v-model="selected" :options="allVersions"
            group-values="options" group-label="label" :group-select="true"
            :multiple="true"
            :placeholder="$lang('Wybierz wersje')"
            :selectLabel="$lang('Wybierz wersję')"
            :selectedLabel="$lang('Wybrane')"
            :deselectLabel="$lang('Usuń wersję')"
            :selectGroupLabel="$lang('Wybierz wszystkie wersje')"
            :deselectGroupLabel="$lang('Usuń wszystkie wersje')"
        ></multiselect>

        <input v-for="version in selected" name="versions[]" :value="version" hidden>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";

    export default {
        name: 'tasks-by-version-inputs',
        components: {Multiselect},
        props: ['versions'],
        data() {
            return {
                selected: [],
                allVersions: [{
                    label: 'Wszystkie',
                    options: this.versions
                }],
            }
        },
        computed: {
            valid() {
                return this.selected.length > 0;
            }
        },
        watch: {
            valid() {
                this.$emit('validation', this.valid);
            },
        }
    }
</script>
